import styled from 'styled-components';

interface ModalProps {
  isVisible: boolean
}

export const ModalResult = styled.div<ModalProps>`
  position: absolute;
  z-index: 10;
  height: calc(100% - 57px);
  width: calc(100% - 200px);
  scroll-behavior: unset;
  background-color: rgba(0, 0, 0, 0.3);
  display: ${(props) => props.isVisible ? 'flex' : 'none'};
  flex-direction: column;  
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    height: calc(100vh - 114px);
    width: 100vw;
  }

  main {
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    width: 50%;
    max-height: 85vh;
    padding: 30px 20px;
    border-radius: 5px; 
    text-align: center;
    -ms-overflow-style: none;  
    scrollbar-width: none;
    overflow-y: scroll;
    overflow-x: hidden;
    align-items: center;
    border: 2px solid ${({ theme }) => theme.text};

    ::-webkit-scrollbar {
      display: none;
    }
    @media(max-width: 1000px) {
      width: 70%;
    }
    
    @media(max-width: 800px) {
      width: 80%;
    }
    @media(max-width: 600px) {
      width: 70%;
    }
    @media(max-width: 500px) {
      width: 90%;
      margin-bottom: 20px;
    }
    @media (max-width: 800px) and  (max-height:700px) {
      max-height: 80vh;
    }
    @media (max-width: 450px) and  (max-height:900px) {
      max-height: 80vh;
    }
    @media (max-width: 450px)  and  (max-height:750px){
      max-height: 70vh;
    }
    button {
      margin-top: 20px;
      background-image: linear-gradient(to top right, rgba(134,79,151,1), rgba(255,180,72,1));
      color: whitesmoke;
      border-radius: 5px;
      width: 140px;
      font-size: 1.3rem;
      border: 2px solid white;
      height: 42px;
      cursor: pointer;
    }

    h1, h2 {
      color: ${({ theme }) => theme.text};
    }

    h1 {
      font-size: 2rem;
      margin-bottom: -4px;
    }

    h2 {
      font-size: 1.8rem;
      margin-bottom: -5px;
    }

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    span {
      font-size: 1.8rem;
      color: #8c4e9a;
      text-transform: uppercase;
      font-weight: bold;
    }

    p {
      font-size: 1.5rem;
      margin-bottom: -10px;
    }
    
    img {
      margin-top: 20px;
      width: 55%;
    }
  }
`